"use client"
import { useRouter } from "next/navigation";
export default function I18nBtn() {
  const router = useRouter();
  function setLang(lang: string) {
    document.cookie = `lang=${lang}; path=/; max-age=31536000`;
    setTimeout(() => {
      router.refresh();
    })
  }
  
  return (
    <div className="relative group -translate-x-8 before:content-[''] before:absolute before:left-0 before:top-0 before:bottom-3.5 before:w-full before:h-[50px] ">
        <div className=" text-lg text-[#333] cursor-pointer relative">
            <svg viewBox="0 0 24 24" width="1.2em" height="1.2em">
                <path fill="currentColor" d="m18.5 10l4.4 11h-2.155l-1.201-3h-4.09l-1.199 3h-2.154L16.5 10h2zM10 2v2h6v2h-1.968a18.222 18.222 0 0 1-3.62 6.301a14.864 14.864 0 0 0 2.336 1.707l-.751 1.878A17.015 17.015 0 0 1 9 13.725a16.676 16.676 0 0 1-6.201 3.548l-.536-1.929a14.7 14.7 0 0 0 5.327-3.042A18.078 18.078 0 0 1 4.767 8h2.24A16.032 16.032 0 0 0 9 10.877a16.165 16.165 0 0 0 2.91-4.876L2 6V4h6V2h2zm7.5 10.885L16.253 16h2.492L17.5 12.885z">
                </path>
            </svg>
            <div className="absolute top-[30px] right-[0px] group-hover:block hidden bg-white shadow-[0_2px_4px_0_rgba(0,0,0,0.1)]">
                <a onClick={() => setLang('en')} className="py-2 text-black text-sm w-[76px] text-center block hover:bg-[#f5f5f5]">English</a>
                <a onClick={() => setLang('cn')} className="py-2 text-black text-sm w-[76px] text-center block hover:bg-[#f5f5f5]">简体中文</a>
            </div>
        </div>
    </div>
  )
}
